import { createMutation } from '../../../../utils/mutations';
import { createProviderConnection } from '../../../../../organisations/src/core/api';

interface ReconnectOrganisationInput {
  datasourceId: string;
  integrationSlug: string;
  organisationId: string;
  successUrl: string;
  userId: string;
  workspaceId: string;
}

export const reconnectOrganisationMutation = () =>
  createMutation<ReconnectOrganisationInput, Awaited<ReturnType<typeof createProviderConnection>>>({
    mutationFn: ({ datasourceId, integrationSlug, organisationId, successUrl, userId, workspaceId }) =>
      createProviderConnection(workspaceId, organisationId, {
        workspace_id: workspaceId,
        organisation_id: organisationId,
        datasource_id: datasourceId,
        integration: integrationSlug,
        provider: integrationSlug === 'xero' ? 'xero' : 'ledgerflow',
        success_url: successUrl,
        user_id: userId
      })
  });
